'use es6';

import { converterNames } from 'rich-text-lib/lib/pastePreProcess';
import { xssTransformIn } from 'rich-text-lib/lib/xssTransform';
import parseHTML from 'rich-text-lib/utils/parseHTML';
import tinymce from 'tinymce';
import { uploadImagesByUrl } from 'tinymce-data/api/FileManager';
import { hsimageConfig } from '../constants/image';
import { __HS_PASTE } from '../constants/plugins';
import { getFetchEmbedCode, onInsertIframeEmbed } from '../hsmedia/shared';
import { handleTextDirectionality } from '../utils/directionality';
import { getImageLoadingDefaultValue, getImagePluginSetting } from '../utils/image';
import { constructPasteConfig, getPasteInfo, getPastePreProcessTransform } from '../utils/paste';
import { handleImageSources } from './utils';
let pasteInfo = {};
const setPasteInfo = newInfo => {
  pasteInfo = Object.assign({}, pasteInfo, newInfo);
};
const resetPasteInfo = () => {
  pasteInfo = {
    converter: x => x,
    type: 'unknown paste type',
    pasteSource: 'unknown paste source',
    pasteContent: 'unknown paste content'
  };
};
function pastePlugin(editor) {
  resetPasteInfo();
  const fetchEmbedCode = getFetchEmbedCode(editor.getParam('apiClient'));
  const pasteConfig = Object.assign({}, constructPasteConfig(editor));
  editor.on('paste', event => {
    resetPasteInfo();
    setPasteInfo(getPasteInfo(event, pasteConfig));
    const {
      didTransform,
      transformedContent,
      composedTransformConverter
    } = getPastePreProcessTransform(pasteInfo);
    if (didTransform) {
      const {
        pasteContent
      } = pasteInfo;
      event.clipboardData.getData = format => {
        if (format !== 'text/html') {
          return pasteContent;
        }
        return transformedContent;
      };
      setPasteInfo({
        converter: composedTransformConverter
      });
    }
  });
  editor.on('PastePreProcess', event => {
    const {
      allowEmbedUrlPasting
    } = pasteConfig;
    const {
      converter,
      embedData
    } = pasteInfo;
    if (allowEmbedUrlPasting && embedData) {
      event.preventDefault();
      event.stopPropagation();
      editor.fire('uploadProgress', {
        percentLoaded: 10
      });
      fetchEmbedCode(embedData).then(result => {
        editor.fire('uploadComplete');
        onInsertIframeEmbed(editor, result, 'paste');
      }).catch(err => {
        const {
          url
        } = embedData;
        console.error(`Could not generate embed code from url: ${url}`, err);
        editor.fire('uploadFailure');
        editor.insertContent(url);
      });
    } else {
      const doc = parseHTML(converter(event.content));
      xssTransformIn(doc);
      event.content = doc.innerHTML;
    }
  });
  editor.on('PastePostProcess', event => {
    const {
      uploadedFileAccess
    } = pasteConfig;
    const {
      pasteSource
    } = pasteInfo;
    const {
      CONVERT_GOOGLE_TO_HTML
    } = converterNames;
    const imageLoadingDefaultValue = getImageLoadingDefaultValue(editor);
    const stripImageBlobs = !!getImagePluginSetting(editor, hsimageConfig.STRIP_IMAGE_BLOBS);
    if (imageLoadingDefaultValue || stripImageBlobs) {
      Array.from(event.node.querySelectorAll('img')).forEach(image => {
        image.setAttribute('data-mce-paste', 'true');
      });
    }
    handleTextDirectionality(editor, event.node);
    if (pasteSource === CONVERT_GOOGLE_TO_HTML && !stripImageBlobs) {
      const {
        node: doc
      } = event;
      const {
        apiClient
      } = editor.settings;
      uploadImagesByUrl(doc, apiClient, pasteSource, uploadedFileAccess).then(urlEntries => {
        handleImageSources(editor, urlEntries);
      }).catch(() => {
        if (!uploadedFileAccess) {
          setTimeout(() => {
            throw new Error('[uploadedFileAccess] must be provided to upload images pasted from Google Docs');
          });
        }
      });
    }
  });
}
export const HS_PASTE = __HS_PASTE;
tinymce.PluginManager.add(HS_PASTE, pastePlugin);